/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component} from '@angular/core';
import template from './role-item-page.component.html';

import {AdminResourceItemPageBase} from '../../common/controller/admin-resource-item-page-base';

@Component({
  standalone: false,
  selector: 'adn-role-item-page',
  template
})
export class RoleItemPageComponent extends AdminResourceItemPageBase {
  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }
}
